module.exports = __webpack_public_path__ + "img/logo.cc04faa3.png";